import { render, staticRenderFns } from "./ChatRatingTicket.vue?vue&type=template&id=b7e1a83a&"
import script from "./ChatRatingTicket.vue?vue&type=script&lang=js&"
export * from "./ChatRatingTicket.vue?vue&type=script&lang=js&"
import style0 from "./ChatRatingTicket.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports